/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferSchedulesResponse,
  AccountTransferFund: (params: vp.AccountTransferSchedulesRequest) => void,
  reset: () => void,
  AccountTransferFundAsync: (
    requestParams: vp.AccountTransferSchedulesRequest,
  ) => Promise<vp.AccountTransferSchedulesResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAccountTransferSchedules: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferSchedulesRequest>({});
  const [response, setResponse] = useState<vp.AccountTransferSchedulesResponse>({
    Success: false,
    ErrorMessage: '',
    ScheduledClientAccountTransfers: {},
  });

  useEffect(() => {
    if (!shouldSendRequest) return () => {};

    const PostAccountTransferFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.fetchAccountTransferSchedules(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSendRequest) void PostAccountTransferFund();
    setSendRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.AccountTransferSchedulesRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ScheduledClientAccountTransfers: {},
      });
      setSendRequest(false);
    },
    async (requestParams: vp.AccountTransferSchedulesRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchAccountTransferSchedules(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAccountTransferSchedules);
